// After a deploy the old hashed chunks are removed from S3, so a tab still running
// the previous build fails on lazy route chunks. Reload once to pick up the new build.
const KEY = 'chunk-reload-at'

export default ({ app }) => {
	app.router.onError((error) => {
		if (!/Loading (CSS )?chunk/i.test(error && error.message)) { return }

		const last = Number(sessionStorage.getItem(KEY)) || 0
		// guard against a reload loop if the chunk is really missing
		if (Date.now() - last < 10000) { return }

		sessionStorage.setItem(KEY, String(Date.now()))
		window.location.reload()
	})
}
